export default __webpack_public_path__ + "static/media/prosessing.47778cc8.svg";